import { BRAND } from "../data/brand";
import WhatsAppIcon from "./WhatsAppIcon";

export default function FloatingWhatsApp() {
  return (
    <a
      href={BRAND.whatsapp}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-btn"
      aria-label="Scrivici su WhatsApp"
      className="fixed z-40 bottom-6 left-6 flex items-center gap-3 px-5 py-3.5 bg-[#25D366] text-white shadow-xl shadow-[#25D366]/30 hover:bg-[#1ebe57] hover:scale-105 transition-all rounded-full group"
    >
      <span className="relative flex">
        <span className="absolute inline-flex h-full w-full rounded-full bg-white opacity-60 animate-ping" />
        <WhatsAppIcon className="relative w-6 h-6" />
      </span>
      <span className="hidden sm:inline font-heading font-bold text-sm tracking-tight">
        Scrivici su WhatsApp
      </span>
    </a>
  );
}
